import { useNavigate } from "react-router-dom";
import { useRef, useState } from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { io } from "socket.io-client";
import Peer from "simple-peer";
import { createContext } from "react";
const ChatContext = createContext();

// const socket = io("http://localhost:5000");
const socket = io("https://vediocallserver.onrender.com");

const ChatProvider = ({ children }) => {
  // const ENDPOINT = "http://localhost:5000";
  let count = 0;
  const ENDPOINT = "https://vediocallserver.onrender.com";
  const [stream, setStream] = useState();
  const [me, setMe] = useState("");
  const [name, setName] = useState("");
  const [call, setCall] = useState({});
  const [callAccepted, setCallAccepted] = useState(false);
  const [callEnded, setCallEnded] = useState(false);
  const [calling, setCalling] = useState(false);
  const [online, setOnline] = useState([]);
  const [showLobby, setShowlobby] = useState(false);
  const [loading, setLoading] = useState(false);
  const myVideo = useRef();

  const userVideo = useRef();
  const connectionRef = useRef();
  const user = JSON.parse(localStorage.getItem("Vediocalltoken"));

  useEffect(() => {
    socket.on("me", (id) => setMe(id));

    socket.on("active-users", (data) => {
      setOnline(data);
    });
    socket.on('callended',()=>{
      window.location.reload()
      
    })

    socket.on("callUser", ({ from, name: callerName, signal }) => {
      setCall({ isReceivingCall: true, from, name: callerName, signal });
    });
  }, []);

  const answerCall = () => {
    setCallAccepted(true);
    setShowlobby(true);

    const peer = new Peer({ initiator: false, trickle: false, stream });
    peer.on("signal", (data) => {
      socket.emit("answerCall", { signal: data, to: call.from });
    });
    peer.on("stream", (data) => {
      userVideo.current.srcObject = data;
    });

    peer.signal(call.signal);
    connectionRef.current = peer;
  };
  const callRejected = () => {
    socket.emit("rejectCall", { to: call.from });
    setCall({ isReceivingCall: false });
  };
  const callUser = (id) => {
    // alert(id)
    const peer = new Peer({ initiator: true, trickle: false, stream });
    peer.on("signal", (data) => {
      socket.emit("callUser", {
        userToCall: id,
        signalData: data,
        from: me,
        name,
      });
    });
    peer.on("stream", (data) => {
      userVideo.current.srcObject = data;
    });
    socket.on("callAccepted", (signal) => {
      setShowlobby(true);
      setCalling(false);
      peer.signal(signal);
    });
    socket.on("endedRes", (res) => {
      alert(res);
      setCalling(false);
    });

    connectionRef.current = peer;
  };

  const leaveCall = () => {
    setCallEnded(true);

    connectionRef.current.destroy();

    window.location.reload();
  };
  return (
    <ChatContext.Provider
      value={{
        call,
        callAccepted,
        setStream,
        userVideo,
        stream,
        name,
        setName,
        callEnded,
        me,
        callUser,
        leaveCall,
        answerCall,
        callRejected,
        calling,
       
        socket,
        setCalling,
        ENDPOINT,
        user,
        myVideo,
        online,
        setOnline,
        showLobby,
        setShowlobby,
        loading,
        setLoading,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};
export const ChatState = () => {
  return useContext(ChatContext);
};

export default ChatProvider;
